<template>
<w-sliding-popup ref="slidingPopup" :title="title" width="600px" @close="onClosePopup">
  <el-form ref="templateForm" slot="content" :model="templateData">
    <el-form-item label="템플릿 이름" prop="templateName" :rules="[{ required: true, message: '템플릿 이름을 입력하십시오.', trigger: ['blur'] }]">
      <el-input v-model="templateData.templateName" />
    </el-form-item>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" type="solid" size="large" @click="onClickSaveButton">저장</el-button>
    <el-button size="large" @click="onClosePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import map from 'lodash/map';
import partialRight from 'lodash/partialRight';
import pick from 'lodash/pick';
import clone from 'lodash/clone';
// import filter from 'lodash/filter';
// import pullAllWith from 'lodash/pullAllWith';
// import union from 'lodash/union';

import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import ChartAPI from '@/api/chart/chart-analysis';

export default {
  name: 'WAddTemplatePopup',
  props: {
    templateInfo: Object,
    chartList: Array,
  },
  data() {
    return {
      templateName: null,
      title: null,
      templateData: {},
    };
  },
  computed: {
    valid() {
      return !isEmpty(this.templateData.templateName);
    },
  },
  methods: {
    /**
     * 슬라이딩 팝업을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open() {
      this.templateData = clone(this.templateInfo);
      this.$refs.slidingPopup.visible = true;

      // 팝업창 타이틀
      this.$nextTick(() => {
        if (isEmpty(this.templateData.templateSeq)) {
          this.title = '템플릿 저장';
        } else {
          this.title = '다른 이름으로 저장';
          this.templateData.templateName = null;
        }
      });
    },
    /**
     * 슬라이딩 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 템플릿을 저장 or 다른 이름으로 저장 한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickSaveButton() {
      this.$refs.templateForm.validate((valid) => {
        if (valid) {
          const templateName = this.templateData.templateName;
          const chartList = this.chartList;

          // 저장
          const charts = map(chartList, partialRight(pick, ['items', 'orderbyIndex']));
          const target = '템플릿';
          const action = msgUtil.action.SAVE;
          ChartAPI.addPerfChartTemplate({
            templateName,
            charts,
          })
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('saveTemplate', response.data.data);
                this.onClosePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, true));
            });
        } else {
          this.$message(msgUtil.getRequireMsgData(msgUtil.action.INPUT, '값'));
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/chart/components/popup/AddTemplatePopup.vue